export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7785.0dd73fa7.jpg";